export default __webpack_public_path__ + "7ce98c959818bde7776ff152e21332ca.svg";